// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================================
   PAGE
================================= */

.e2e_clients_page{

  background:#ffffff;

  padding:22px;

  border-radius:22px;

  border:1px solid #edf2f7;

  box-shadow:
    0 8px 28px rgba(15,23,42,0.05);
}

/* =================================
   TOP HEADER
================================= */

.e2e_clients_top{

  display:flex;

  justify-content:space-between;

  align-items:center;

  margin-bottom:24px;

  gap:18px;

  flex-wrap:wrap;
}

/* LEFT */

.e2e_clients_left{

  display:flex;

  flex-direction:column;
}

/* TITLE */

.e2e_clients_left h2{

  font-size:24px;

  font-weight:800;

  color:#0f172a;

  margin:0;

  letter-spacing:0.3px;
}

/* UNDERLINE */

.e2e_clients_heading_line{

  width:90px;

  height:4px;

  margin-top:10px;

  border-radius:20px;

  background:
    linear-gradient(
      90deg,
      #2563eb,
      #7c3aed
    );
}

/* RIGHT */

.e2e_clients_right{

  display:flex;

  align-items:center;
}

/* BUTTON */

.e2e_clients_right button{

  border:none;

  background:
    linear-gradient(
      135deg,
      #1677ff,
      #2563eb
    );

  color:white;

  height:42px;

  padding:0 22px;

  border-radius:12px;

  font-size:13px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;

  box-shadow:
    0 4px 14px rgba(37,99,235,0.18);
}

.e2e_clients_right button:hover{

  transform:translateY(-2px);
}

/* =================================
   FILTERS
================================= */

.e2e_clients_filters{

  background:#f8fafc;

  border:1px solid #edf2f7;

  border-radius:18px;

  padding:18px 20px;

  display:flex;

  justify-content:space-between;

  align-items:center;

  gap:20px;

  margin-bottom:24px;
}

/* LEFT */

.e2e_clients_filter_left{

  display:flex;

  align-items:center;

  gap:16px;

  flex-wrap:wrap;
}

/* GROUP */

.e2e_clients_filter_group{

  display:flex;

  align-items:center;

  gap:10px;
}

/* LABEL */

.e2e_clients_filter_group label{

  font-size:13px;

  font-weight:700;

  color:#334155;
}

/* TEXT */

.e2e_clients_filter_group span{

  font-size:13px;

  font-weight:600;

  color:#64748b;
}

/* SELECT */

.e2e_clients_filter_group select{

  height:40px;

  min-width:180px;

  padding:0 14px;

  border:1px solid #dbe2ea;

  border-radius:12px;

  outline:none;

  background:white;

  font-size:13px;

  font-weight:600;

  color:#0f172a;

  cursor:pointer;

  transition:0.3s ease;
}

.e2e_clients_filter_group select:focus{

  border-color:#2563eb;

  box-shadow:
    0 0 0 3px rgba(37,99,235,0.08);
}

/* SMALL SELECT */

.smallSelect{

  min-width:75px !important;
}

/* REPORT BUTTON */

.e2e_clients_report_btn{

  height:40px;

  border:none;

  background:
    linear-gradient(
      135deg,
      #06b6d4,
      #0891b2
    );

  color:white;

  padding:0 18px;

  border-radius:12px;

  font-size:13px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;
}

.e2e_clients_report_btn:hover{

  transform:translateY(-2px);
}

/* RIGHT */

.e2e_clients_filter_right{

  display:flex;

  align-items:center;
}

/* SEARCH */

.e2e_clients_filter_right input{

  width:260px;

  height:40px;

  padding:0 16px;

  border:1px solid #dbe2ea;

  border-radius:12px;

  outline:none;

  background:white;

  font-size:13px;

  transition:0.3s ease;
}

.e2e_clients_filter_right input:focus{

  border-color:#2563eb;

  box-shadow:
    0 0 0 3px rgba(37,99,235,0.08);
}

/* =================================
   TABLE
================================= */

.e2e_clients_table_wrapper{

  overflow-x:auto;

  margin-top:8px;
}

/* TABLE */

.e2e_clients_table{

  width:100%;

  border-collapse:separate;

  border-spacing:0 12px;

  table-layout:fixed;
}

/* HEADER */

.e2e_clients_table_head_row{

  background:#f8fafc;
}

/* TH */

.e2e_clients_th{

  padding:16px 14px;

  font-size:12px;

  font-weight:800;

  text-transform:uppercase;

  color:#475569;

  border-top:1px solid #e2e8f0;

  border-bottom:1px solid #e2e8f0;

  text-align:center;

  letter-spacing:0.4px;
}
.e2e_clients_th{

  padding:16px 20px;

  font-size:14px;

  font-weight:800;

  text-transform:uppercase;

  color:#475569;

  border-top:1px solid #e2e8f0;

  border-bottom:1px solid #e2e8f0;

  text-align:center;

  letter-spacing:0.4px;

  margin-right:10px;
}

/* ROW */

.e2e_clients_table_row{

  background:white;

  transition:0.3s ease;

  box-shadow:
    0 3px 12px rgba(15,23,42,0.04);
}

.e2e_clients_table_row:hover{

  transform:translateY(-2px);

  box-shadow:
    0 10px 24px rgba(15,23,42,0.08);
}

/* TD */

.e2e_clients_td{

  padding:18px 16px;

  vertical-align:middle;

  font-size:15px;

  font-weight:600;

  color:#0f172a;

  border-top:1px solid #f1f5f9;

  border-bottom:1px solid #f1f5f9;

  text-align:center;
}

/* COLUMN WIDTHS */

.e2e_clients_th_id,
.e2e_clients_td_id{

  width:50px;
}

.e2e_clients_th_client,
.e2e_clients_td_client{

  width:34%;

  text-align:left;
}

.e2e_clients_th_recruiter,
.e2e_clients_td_recruiter{
  padding-right: 10%;
  width:40%;
}

.e2e_clients_th_email,
.e2e_clients_td_email{
  padding-right: 10%;
  width:46%;
}

.e2e_clients_th_action,
.e2e_clients_td_action{

  width:220px;
}

/* RADIUS */

.e2e_clients_table_row td:first-child{

  border-left:1px solid #f1f5f9;

  border-top-left-radius:14px;

  border-bottom-left-radius:14px;

  font-weight:800;

  color:#2563eb;
}

.e2e_clients_table_row td:last-child{

  border-right:1px solid #f1f5f9;

  border-top-right-radius:14px;

  border-bottom-right-radius:14px;
}

/* DETAILS */

.e2e_clients_details{

  display:flex;

  flex-direction:column;

  gap:8px;
}

.e2e_clients_text{

  margin:0;

  line-height:1.5;

  color:#475569;

  font-size:13px;
}

.e2e_clients_text strong{

  color:#0f172a;

  margin-left:5px;
}

/* ACTIONS */

.e2e_clients_actions{

  display:flex;

  align-items:center;

  justify-content:center;

  gap:8px;

  flex-wrap:nowrap;
}

/* BUTTONS */

.viewBtn,
.editBtn,
.deleteBtn{

  border:none;

  min-width:64px;

  height:32px;

  border-radius:10px;

  font-size:11px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;
}

/* VIEW */

.viewBtn{

  background:#dbeafe;

  color:#2563eb;
}

.viewBtn:hover{

  background:#2563eb;

  color:white;
}

/* EDIT */

.editBtn{

  background:#fef3c7;

  color:#d97706;
}

.editBtn:hover{

  background:#f59e0b;

  color:white;
}

/* DELETE */

.deleteBtn{

  background:#fee2e2;

  color:#dc2626;
}

.deleteBtn:hover{

  background:#dc2626;

  color:white;
}

/* SCROLLBAR */

.e2e_clients_table_wrapper::-webkit-scrollbar{

  height:7px;
}

.e2e_clients_table_wrapper::-webkit-scrollbar-thumb{

  background:#cbd5e1;

  border-radius:20px;
}

/* =================================
   RESPONSIVE
================================= */

@media screen and (max-width:1100px){

  .e2e_clients_filters{

    flex-direction:column;

    align-items:stretch;
  }

  .e2e_clients_filter_left{

    width:100%;

    justify-content:space-between;
  }

  .e2e_clients_filter_right{

    width:100%;
  }

  .e2e_clients_filter_right input{

    width:100%;
  }

}

@media screen and (max-width:768px){

  .e2e_clients_page{

    padding:16px;
  }

  .e2e_clients_top{

    flex-direction:column;

    align-items:flex-start;
  }

  .e2e_clients_left h2{

    font-size:20px;
  }

  .e2e_clients_filter_left{

    flex-direction:column;

    align-items:stretch;
  }

  .e2e_clients_filter_group{

    width:100%;

    flex-direction:column;

    align-items:flex-start;
  }

  .e2e_clients_filter_group select{

    width:100%;
  }

  .e2e_clients_report_btn{

    width:100%;
  }

  .e2e_clients_table{

    min-width:1000px;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/client.css"],"names":[],"mappings":"AAAA;;mCAEmC;;AAEnC;;EAEE,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,wBAAwB;;EAExB;kCACgC;AAClC;;AAEA;;mCAEmC;;AAEnC;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA,SAAS;;AAET;;EAEE,YAAY;;EAEZ,qBAAqB;AACvB;;AAEA,UAAU;;AAEV;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,QAAQ;;EAER,oBAAoB;AACtB;;AAEA,cAAc;;AAEd;;EAEE,UAAU;;EAEV,UAAU;;EAEV,eAAe;;EAEf,kBAAkB;;EAElB;;;;;KAKG;AACL;;AAEA,UAAU;;AAEV;;EAEE,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX;;;;;KAKG;;EAEH,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;;EAEpB;mCACiC;AACnC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;mCAEmC;;AAEnC;;EAEE,kBAAkB;;EAElB,wBAAwB;;EAExB,kBAAkB;;EAElB,iBAAiB;;EAEjB,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,QAAQ;;EAER,kBAAkB;AACpB;;AAEA,SAAS;;AAET;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA,UAAU;;AAEV;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;AACV;;AAEA,UAAU;;AAEV;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA,SAAS;;AAET;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,eAAe;;EAEf,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,gBAAgB;;EAEhB,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,cAAc;;EAEd,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;;EAEpB;kCACgC;AAClC;;AAEA,iBAAiB;;AAEjB;;EAEE,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB;;EAEE,WAAW;;EAEX,WAAW;;EAEX;;;;;KAKG;;EAEH,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,UAAU;;AAEV;;EAEE,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,gBAAgB;;EAEhB,cAAc;;EAEd,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;;EAEpB;kCACgC;AAClC;;AAEA;;mCAEmC;;AAEnC;;EAEE,eAAe;;EAEf,cAAc;AAChB;;AAEA,UAAU;;AAEV;;EAEE,UAAU;;EAEV,wBAAwB;;EAExB,qBAAqB;;EAErB,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;;EAEE,kBAAkB;AACpB;;AAEA,OAAO;;AAEP;;EAEE,iBAAiB;;EAEjB,cAAc;;EAEd,eAAe;;EAEf,wBAAwB;;EAExB,aAAa;;EAEb,4BAA4B;;EAE5B,+BAA+B;;EAE/B,iBAAiB;;EAEjB,oBAAoB;AACtB;AACA;;EAEE,iBAAiB;;EAEjB,cAAc;;EAEd,eAAe;;EAEf,wBAAwB;;EAExB,aAAa;;EAEb,4BAA4B;;EAE5B,+BAA+B;;EAE/B,iBAAiB;;EAEjB,oBAAoB;;EAEpB,iBAAiB;AACnB;;AAEA,QAAQ;;AAER;;EAEE,gBAAgB;;EAEhB,oBAAoB;;EAEpB;kCACgC;AAClC;;AAEA;;EAEE,0BAA0B;;EAE1B;mCACiC;AACnC;;AAEA,OAAO;;AAEP;;EAEE,iBAAiB;;EAEjB,qBAAqB;;EAErB,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,4BAA4B;;EAE5B,+BAA+B;;EAE/B,iBAAiB;AACnB;;AAEA,kBAAkB;;AAElB;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,SAAS;;EAET,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;EAGE,WAAW;AACb;;AAEA,WAAW;;AAEX;;EAEE,6BAA6B;;EAE7B,2BAA2B;;EAE3B,8BAA8B;;EAE9B,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,8BAA8B;;EAE9B,4BAA4B;;EAE5B,+BAA+B;AACjC;;AAEA,YAAY;;AAEZ;;EAEE,YAAY;;EAEZ,qBAAqB;;EAErB,OAAO;AACT;;AAEA;;EAEE,QAAQ;;EAER,eAAe;;EAEf,aAAa;;EAEb,cAAc;AAChB;;AAEA;;EAEE,aAAa;;EAEb,eAAe;AACjB;;AAEA,YAAY;;AAEZ;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,sBAAsB;;EAEtB,OAAO;;EAEP,gBAAgB;AAClB;;AAEA,YAAY;;AAEZ;;;;EAIE,WAAW;;EAEX,cAAc;;EAEd,WAAW;;EAEX,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;AACtB;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,WAAW;;AAEX;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,cAAc;;AAEd;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;;mCAEmC;;AAEnC;;EAEE;;IAEE,qBAAqB;;IAErB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;;IAEV,6BAA6B;EAC/B;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;AAEF;;AAEA;;EAEE;;IAEE,YAAY;EACd;;EAEA;;IAEE,qBAAqB;;IAErB,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;;IAErB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;;IAEV,qBAAqB;;IAErB,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;EAClB;;AAEF","sourcesContent":["/* =================================\r\n   PAGE\r\n================================= */\r\n\r\n.e2e_clients_page{\r\n\r\n  background:#ffffff;\r\n\r\n  padding:22px;\r\n\r\n  border-radius:22px;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  box-shadow:\r\n    0 8px 28px rgba(15,23,42,0.05);\r\n}\r\n\r\n/* =================================\r\n   TOP HEADER\r\n================================= */\r\n\r\n.e2e_clients_top{\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  margin-bottom:24px;\r\n\r\n  gap:18px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* LEFT */\r\n\r\n.e2e_clients_left{\r\n\r\n  display:flex;\r\n\r\n  flex-direction:column;\r\n}\r\n\r\n/* TITLE */\r\n\r\n.e2e_clients_left h2{\r\n\r\n  font-size:24px;\r\n\r\n  font-weight:800;\r\n\r\n  color:#0f172a;\r\n\r\n  margin:0;\r\n\r\n  letter-spacing:0.3px;\r\n}\r\n\r\n/* UNDERLINE */\r\n\r\n.e2e_clients_heading_line{\r\n\r\n  width:90px;\r\n\r\n  height:4px;\r\n\r\n  margin-top:10px;\r\n\r\n  border-radius:20px;\r\n\r\n  background:\r\n    linear-gradient(\r\n      90deg,\r\n      #2563eb,\r\n      #7c3aed\r\n    );\r\n}\r\n\r\n/* RIGHT */\r\n\r\n.e2e_clients_right{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n}\r\n\r\n/* BUTTON */\r\n\r\n.e2e_clients_right button{\r\n\r\n  border:none;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #1677ff,\r\n      #2563eb\r\n    );\r\n\r\n  color:white;\r\n\r\n  height:42px;\r\n\r\n  padding:0 22px;\r\n\r\n  border-radius:12px;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n\r\n  box-shadow:\r\n    0 4px 14px rgba(37,99,235,0.18);\r\n}\r\n\r\n.e2e_clients_right button:hover{\r\n\r\n  transform:translateY(-2px);\r\n}\r\n\r\n/* =================================\r\n   FILTERS\r\n================================= */\r\n\r\n.e2e_clients_filters{\r\n\r\n  background:#f8fafc;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  border-radius:18px;\r\n\r\n  padding:18px 20px;\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  gap:20px;\r\n\r\n  margin-bottom:24px;\r\n}\r\n\r\n/* LEFT */\r\n\r\n.e2e_clients_filter_left{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:16px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* GROUP */\r\n\r\n.e2e_clients_filter_group{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:10px;\r\n}\r\n\r\n/* LABEL */\r\n\r\n.e2e_clients_filter_group label{\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:700;\r\n\r\n  color:#334155;\r\n}\r\n\r\n/* TEXT */\r\n\r\n.e2e_clients_filter_group span{\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#64748b;\r\n}\r\n\r\n/* SELECT */\r\n\r\n.e2e_clients_filter_group select{\r\n\r\n  height:40px;\r\n\r\n  min-width:180px;\r\n\r\n  padding:0 14px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:12px;\r\n\r\n  outline:none;\r\n\r\n  background:white;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#0f172a;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_clients_filter_group select:focus{\r\n\r\n  border-color:#2563eb;\r\n\r\n  box-shadow:\r\n    0 0 0 3px rgba(37,99,235,0.08);\r\n}\r\n\r\n/* SMALL SELECT */\r\n\r\n.smallSelect{\r\n\r\n  min-width:75px !important;\r\n}\r\n\r\n/* REPORT BUTTON */\r\n\r\n.e2e_clients_report_btn{\r\n\r\n  height:40px;\r\n\r\n  border:none;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #06b6d4,\r\n      #0891b2\r\n    );\r\n\r\n  color:white;\r\n\r\n  padding:0 18px;\r\n\r\n  border-radius:12px;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_clients_report_btn:hover{\r\n\r\n  transform:translateY(-2px);\r\n}\r\n\r\n/* RIGHT */\r\n\r\n.e2e_clients_filter_right{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n}\r\n\r\n/* SEARCH */\r\n\r\n.e2e_clients_filter_right input{\r\n\r\n  width:260px;\r\n\r\n  height:40px;\r\n\r\n  padding:0 16px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:12px;\r\n\r\n  outline:none;\r\n\r\n  background:white;\r\n\r\n  font-size:13px;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_clients_filter_right input:focus{\r\n\r\n  border-color:#2563eb;\r\n\r\n  box-shadow:\r\n    0 0 0 3px rgba(37,99,235,0.08);\r\n}\r\n\r\n/* =================================\r\n   TABLE\r\n================================= */\r\n\r\n.e2e_clients_table_wrapper{\r\n\r\n  overflow-x:auto;\r\n\r\n  margin-top:8px;\r\n}\r\n\r\n/* TABLE */\r\n\r\n.e2e_clients_table{\r\n\r\n  width:100%;\r\n\r\n  border-collapse:separate;\r\n\r\n  border-spacing:0 12px;\r\n\r\n  table-layout:fixed;\r\n}\r\n\r\n/* HEADER */\r\n\r\n.e2e_clients_table_head_row{\r\n\r\n  background:#f8fafc;\r\n}\r\n\r\n/* TH */\r\n\r\n.e2e_clients_th{\r\n\r\n  padding:16px 14px;\r\n\r\n  font-size:12px;\r\n\r\n  font-weight:800;\r\n\r\n  text-transform:uppercase;\r\n\r\n  color:#475569;\r\n\r\n  border-top:1px solid #e2e8f0;\r\n\r\n  border-bottom:1px solid #e2e8f0;\r\n\r\n  text-align:center;\r\n\r\n  letter-spacing:0.4px;\r\n}\r\n.e2e_clients_th{\r\n\r\n  padding:16px 20px;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:800;\r\n\r\n  text-transform:uppercase;\r\n\r\n  color:#475569;\r\n\r\n  border-top:1px solid #e2e8f0;\r\n\r\n  border-bottom:1px solid #e2e8f0;\r\n\r\n  text-align:center;\r\n\r\n  letter-spacing:0.4px;\r\n\r\n  margin-right:10px;\r\n}\r\n\r\n/* ROW */\r\n\r\n.e2e_clients_table_row{\r\n\r\n  background:white;\r\n\r\n  transition:0.3s ease;\r\n\r\n  box-shadow:\r\n    0 3px 12px rgba(15,23,42,0.04);\r\n}\r\n\r\n.e2e_clients_table_row:hover{\r\n\r\n  transform:translateY(-2px);\r\n\r\n  box-shadow:\r\n    0 10px 24px rgba(15,23,42,0.08);\r\n}\r\n\r\n/* TD */\r\n\r\n.e2e_clients_td{\r\n\r\n  padding:18px 16px;\r\n\r\n  vertical-align:middle;\r\n\r\n  font-size:15px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#0f172a;\r\n\r\n  border-top:1px solid #f1f5f9;\r\n\r\n  border-bottom:1px solid #f1f5f9;\r\n\r\n  text-align:center;\r\n}\r\n\r\n/* COLUMN WIDTHS */\r\n\r\n.e2e_clients_th_id,\r\n.e2e_clients_td_id{\r\n\r\n  width:50px;\r\n}\r\n\r\n.e2e_clients_th_client,\r\n.e2e_clients_td_client{\r\n\r\n  width:34%;\r\n\r\n  text-align:left;\r\n}\r\n\r\n.e2e_clients_th_recruiter,\r\n.e2e_clients_td_recruiter{\r\n  padding-right: 10%;\r\n  width:40%;\r\n}\r\n\r\n.e2e_clients_th_email,\r\n.e2e_clients_td_email{\r\n  padding-right: 10%;\r\n  width:46%;\r\n}\r\n\r\n.e2e_clients_th_action,\r\n.e2e_clients_td_action{\r\n\r\n  width:220px;\r\n}\r\n\r\n/* RADIUS */\r\n\r\n.e2e_clients_table_row td:first-child{\r\n\r\n  border-left:1px solid #f1f5f9;\r\n\r\n  border-top-left-radius:14px;\r\n\r\n  border-bottom-left-radius:14px;\r\n\r\n  font-weight:800;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n.e2e_clients_table_row td:last-child{\r\n\r\n  border-right:1px solid #f1f5f9;\r\n\r\n  border-top-right-radius:14px;\r\n\r\n  border-bottom-right-radius:14px;\r\n}\r\n\r\n/* DETAILS */\r\n\r\n.e2e_clients_details{\r\n\r\n  display:flex;\r\n\r\n  flex-direction:column;\r\n\r\n  gap:8px;\r\n}\r\n\r\n.e2e_clients_text{\r\n\r\n  margin:0;\r\n\r\n  line-height:1.5;\r\n\r\n  color:#475569;\r\n\r\n  font-size:13px;\r\n}\r\n\r\n.e2e_clients_text strong{\r\n\r\n  color:#0f172a;\r\n\r\n  margin-left:5px;\r\n}\r\n\r\n/* ACTIONS */\r\n\r\n.e2e_clients_actions{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  justify-content:center;\r\n\r\n  gap:8px;\r\n\r\n  flex-wrap:nowrap;\r\n}\r\n\r\n/* BUTTONS */\r\n\r\n.viewBtn,\r\n.editBtn,\r\n.deleteBtn{\r\n\r\n  border:none;\r\n\r\n  min-width:64px;\r\n\r\n  height:32px;\r\n\r\n  border-radius:10px;\r\n\r\n  font-size:11px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n/* VIEW */\r\n\r\n.viewBtn{\r\n\r\n  background:#dbeafe;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n.viewBtn:hover{\r\n\r\n  background:#2563eb;\r\n\r\n  color:white;\r\n}\r\n\r\n/* EDIT */\r\n\r\n.editBtn{\r\n\r\n  background:#fef3c7;\r\n\r\n  color:#d97706;\r\n}\r\n\r\n.editBtn:hover{\r\n\r\n  background:#f59e0b;\r\n\r\n  color:white;\r\n}\r\n\r\n/* DELETE */\r\n\r\n.deleteBtn{\r\n\r\n  background:#fee2e2;\r\n\r\n  color:#dc2626;\r\n}\r\n\r\n.deleteBtn:hover{\r\n\r\n  background:#dc2626;\r\n\r\n  color:white;\r\n}\r\n\r\n/* SCROLLBAR */\r\n\r\n.e2e_clients_table_wrapper::-webkit-scrollbar{\r\n\r\n  height:7px;\r\n}\r\n\r\n.e2e_clients_table_wrapper::-webkit-scrollbar-thumb{\r\n\r\n  background:#cbd5e1;\r\n\r\n  border-radius:20px;\r\n}\r\n\r\n/* =================================\r\n   RESPONSIVE\r\n================================= */\r\n\r\n@media screen and (max-width:1100px){\r\n\r\n  .e2e_clients_filters{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n  }\r\n\r\n  .e2e_clients_filter_left{\r\n\r\n    width:100%;\r\n\r\n    justify-content:space-between;\r\n  }\r\n\r\n  .e2e_clients_filter_right{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_clients_filter_right input{\r\n\r\n    width:100%;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width:768px){\r\n\r\n  .e2e_clients_page{\r\n\r\n    padding:16px;\r\n  }\r\n\r\n  .e2e_clients_top{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:flex-start;\r\n  }\r\n\r\n  .e2e_clients_left h2{\r\n\r\n    font-size:20px;\r\n  }\r\n\r\n  .e2e_clients_filter_left{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n  }\r\n\r\n  .e2e_clients_filter_group{\r\n\r\n    width:100%;\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:flex-start;\r\n  }\r\n\r\n  .e2e_clients_filter_group select{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_clients_report_btn{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_clients_table{\r\n\r\n    min-width:1000px;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
